module.exports = __webpack_public_path__ + "static/media/112.70d11997.jpg";